import { TFunction } from 'i18next';

import {
  WithdrawCertificatePermissionErrorCode,
  WithdrawCertificatePermissionErrorCodeTranslationKeyMap,
} from '../enums/withdraw-certificate-permission-error-code';

type CertificatePermissionErrorResponse = {
  message?: string;
};

const extractWithdrawCertificatePermissionErrorCode = (error: unknown): string | undefined => {
  if (error && typeof error === 'object') {
    const response = (error as { response?: { body?: unknown } }).response;
    const responseBody = response?.body;

    if (responseBody && typeof responseBody === 'object') {
      const message = (responseBody as CertificatePermissionErrorResponse).message;

      if (typeof message === 'string' && message.length > 0) {
        return message;
      }
    }

    if (typeof responseBody === 'string') {
      try {
        const parsedBody = JSON.parse(responseBody) as CertificatePermissionErrorResponse;

        if (typeof parsedBody?.message === 'string' && parsedBody.message.length > 0) {
          return parsedBody.message;
        }
      } catch {
        // Keep fallback behavior below when body is not JSON.
      }
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return undefined;
};

export const getWithdrawCertificatePermissionErrorMessage = (
  error: unknown,
  t: TFunction,
): string => {
  const errorCode = extractWithdrawCertificatePermissionErrorCode(error);

  if (
    errorCode &&
    Object.values(WithdrawCertificatePermissionErrorCode).includes(
      errorCode as WithdrawCertificatePermissionErrorCode,
    )
  ) {
    return t(
      `withdrawCertificateConfirmationDialog.errors.${
        WithdrawCertificatePermissionErrorCodeTranslationKeyMap[
          errorCode as WithdrawCertificatePermissionErrorCode
        ]
      }`,
    );
  }

  return t('withdrawCertificateConfirmationDialog.errors.failedToWithdraw');
};
